import { Helmet } from 'react-helmet';
import { Box, Container, Card, CardContent, CardHeader, Divider, Grid, TextField,TableCell,TablePagination,TableBody,TableHead,TableRow,Button,Table,Modal,Typography } from '@material-ui/core';
import customers from 'src/__mocks__/customers';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './style.scss';
import {
  BLOCK_ACCOUNT_API,
  SEARCH_BLOCK_ACCOUNT_BLOCK_API,
} from "../../apiContants";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
  blocked: {
    position: "relative",
    right: "0px",
  },
  options: {
    width: "120px!important",
  },
  mui: {
    border: "1px!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  mui1: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
    paddingLeft: "20px!important",
  },
}));

const Itemblock = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [regaddress, regaddressSet] = useState(Array);
  const [regs, regsSet] = useState(Array);
  const [reg, regSet] = useState(Array);
  const [value, setValues] = React.useState({
    address: "",
    id: "",
  });

  const handleChangeForm = (address) => (event) => {
    setValues({ ...value, [address]: event.target.value });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 999));
    setPage(0);
  };

  const blockuser = async () => {
    const blockid = await axios.put(BLOCK_ACCOUNT_API + value.address);
  };

  const search = async () => {
    const GetID = await axios.get(
      SEARCH_BLOCK_ACCOUNT_BLOCK_API + value.address
    );
    regSet(GetID.data.collectibles);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="lg">
          {/* <Itemblocktbar /> */}
          <Card>
            <CardHeader title="Item Blocked Manager" />
            <Divider />
            <CardContent>
              <Grid container spacing={3}>
                <Grid className={classes.mui} item xs={2}>
                  <span className={classes.paper}>Wallet ADD</span>
                </Grid>
                <Grid className={classes.mui} item xs={2}>
                  <TextField
                    onChange={handleChangeForm("address")}
                    className="containt"
                    placeholder="enter wallet address"
                    inputProps={{
                      min: 0,
                      style: { textAlign: "center", width: "250px" },
                    }}
                    id="standard-basic"
                  />
                </Grid>
                <Grid className={classes.mui} item xs={1}>
                  <span className={classes.paper}>Item ID</span>
                </Grid>
                <Grid className={classes.mui} item xs={2}>
                  <TextField
                    onChange={handleChangeForm("id")}
                    className="containt"
                    placeholder="enter wallet address"
                    inputProps={{
                      min: 0,
                      style: { textAlign: "center", width: "250px" },
                    }}
                    id="standard-basic"
                  />
                </Grid>

                <Grid className={classes.mui1} item xs={2}>
                  <button className={classes.options} type="button">
                    Initialization
                  </button>
                </Grid>
                <Grid className={classes.mui} item xs={2}>
                  <button
                    className={classes.options}
                    type="button"
                    onClick={() => search()}
                  >
                    Search
                  </button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Box sx={{ pt: 3 }}>
            <div className="containerButton">
              <span>Wallet address : {regaddress.address} </span>
              {regaddress.address && (
                <button className={classes.blocked} onClick={() => blockuser()}>
                  Block this user
                </button>
              )}
            </div>
            <Divider />
            <PerfectScrollbar>
              <Box sx={{ minWidth: 1050 }}>
                <div>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Item ID</TableCell>
                        <TableCell>Report By</TableCell>
                        <TableCell>Creator By</TableCell>
                        <TableCell>Blcoked Time</TableCell>
                        <TableCell>More</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reg
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((customer, idx) => (
                          <TableRow hover key={customer.id}>
                            {customer.status !== 0 && (
                              <>
                                <TableCell>{customer.id}</TableCell>
                                <TableCell>{customer.status}</TableCell>
                                <TableCell>
                                  <Typography
                                    color="textPrimary"
                                    variant="body1"
                                  >
                                    {customer.creator}
                                  </Typography>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                  <Button>More</Button>
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </div>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={customers.length}
              onChangePage={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[20]}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Itemblock;
